import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import Spinner from '../spinner'
import styles from './button.module.sass'

const Button = props => {
  const ButtonElement = props.element
  let { type } = props
  if (!type && props.element === 'button') {
    type = 'button'
  }

  return (
    <ButtonElement
      className={classNames(props.className, styles.button, {
        [styles.isFluid]: props.isFluid,
        [styles.isSecondary]: props.isSecondary,
        [styles.isGhost]: props.isGhost,
        [styles.isSmall]: props.isSmall,
      })}
      type={type}
      disabled={props.isDisabled || props.isLoading || props.isFetching}
      onClick={props.onClick}
    >
      {!props.isLoading && props.children}
      {props.isLoading && 'Loading...'}
      {props.isFetching && (
        <div className={styles.spinner}>
          <Spinner isSmall noOffset />
        </div>
      )}
    </ButtonElement>
  )
}

Button.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  type: PropTypes.oneOf(['button', 'reset', 'submit']),
  isFluid: PropTypes.bool,
  isSecondary: PropTypes.bool,
  isGhost: PropTypes.bool,
  isSmall: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  isFetching: PropTypes.bool,
  element: PropTypes.string,
  onClick: PropTypes.func,
}

Button.defaultProps = {
  className: '',
  children: '',
  type: null,
  isFluid: false,
  isGhost: false,
  isSecondary: false,
  isSmall: false,
  isDisabled: false,
  isLoading: false,
  isFetching: false,
  element: 'button',
  onClick: () => {},
}

export default Button
